import * as React from "react";

const SuccessTick = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <g clipPath="url(#clip0_958_11181)">
      <rect width="32" height="32" fill="#EDFFF5" rx="16"></rect>
      <rect
        width="30"
        height="30"
        x="1"
        y="1"
        stroke="#17BD5F"
        strokeWidth="2"
        rx="15"
      ></rect>
      <path
        fill="#17BD5F"
        fillRule="evenodd"
        d="M23.538 10.962a.937.937 0 0 1 0 1.326l-8.75 8.75a.937.937 0 0 1-1.326 0l-4.375-4.375a.937.937 0 1 1 1.326-1.326l3.712 3.712 8.087-8.087a.937.937 0 0 1 1.326 0"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_958_11181">
        <rect width="32" height="32" fill="#fff" rx="16"></rect>
      </clipPath>
    </defs>
  </svg>
);

export default SuccessTick;
